/** Runs every release even when an earlier release fails. */
export class MacroStepCleanup {
  public static async run(releases: ReadonlyArray<() => void | Promise<void>>): Promise<boolean> {
    let confirmed = true;
    for (const release of releases) {
      try { await release(); } catch { confirmed = false; }
    }
    return confirmed;
  }
}
